import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import "./SchoolProjects.css";

const SeptemberpleinApp = () => {
    const navigate = useNavigate();

    // Placeholder images array - replace with actual images later
    const images = [];

    return (
        <div className="page-container">
            <Navbar />
            
            <div className="content-lo1-headings">
                <h1>18 Septemberplein App</h1>
                <p>This project showcases my work on developing the 18 Septemberplein mobile application.</p>
            </div>

            <div className="line"></div>

            <div style={{ padding: '0.1rem 7.5rem' }}>
                <BreadcrumbHeader />
            </div>

            <div className="content-lo1">
                <div className="content-lo1-target">
                    <div className="content-lo1-target-text">
                        <h1>Project Overview</h1>
                        <p>
                            This project demonstrates my understanding of mobile app development and user interface design. 
                            It showcases my ability to create intuitive and functional mobile applications.
                        </p>
                    </div>

                    <div className="content-lo1-target-text2">
                        <h1>Key Features</h1>
                        <p>
                            The project includes a mobile application with various features designed for the 18 Septemberplein area.
                        </p>
                        <h2>What did I learn?</h2>
                        <p>
                            Through this project, I gained valuable insights into mobile development, responsive design, 
                            and user-centered design principles. This experience has been crucial for my growth as a mobile developer.
                        </p>
                    </div>

                    <div className="content-lo1-target-slideshow">
                        {images.length > 0 ? (
                            <Slideshow images={images} />
                        ) : (
                            <div className="slideshow-placeholder">
                                <p>Slideshow Placeholder</p>
                                <p>Add images to the images array to display slideshow</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SeptemberpleinApp;
